import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faChartBar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import FilterContext from "../../../routes/FilterContext";
import Table from "react-bootstrap/Table";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class MySelectedDevelopers extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="widget widgetTable">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>My Selected Developers</p>
          </div>
          <div className="col-lg-3 text-end">
            <Link to="/#" className="pe-3">
              <FontAwesomeIcon icon={faChartBar} />
            </Link>
            <Link to="/#" className="colorBlack">
              <FontAwesomeIcon icon={faEllipsisV} />
            </Link>
          </div>
          <div className="col-lg-12 mt-2">
            <Table responsive hover>
              <thead>
                <tr className="">
                  <th>Developer</th>
                  <th>Built Stock(#)</th>
                  <th>Built Stock(msf)</th>
                  <th className="text-end">Occupancy(%)</th>
                  <th>Passing Rent</th>
                  <th>WALE</th>
                </tr>
              </thead>
              <tbody>
                <tr className="">
                  <td>Embassy</td>
                  <td>92</td>
                  <td>117</td>
                  <td>71.3</td>
                  <td>82.6</td>
                  <td>56</td>
                </tr>
                <tr className="">
                  <td>Embassy</td>
                  <td>92</td>
                  <td>117</td>
                  <td>71.3</td>
                  <td>82.6</td>
                  <td>56</td>
                </tr>
                <tr className="">
                  <td>Embassy</td>
                  <td>92</td>
                  <td>117</td>
                  <td>71.3</td>
                  <td>82.6</td>
                  <td>56</td>
                </tr>
                <tr className="">
                  <td>Embassy</td>
                  <td>92</td>
                  <td>117</td>
                  <td>71.3</td>
                  <td>82.6</td>
                  <td>56</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default MySelectedDevelopers;
